import axios from 'axios'
import { useContext,useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { UserContext } from '../../Routes/Routes1'
import './login.css'

export default function Login(){
    const {state,dispatch}=useContext(UserContext)
    const [data,setData]=useState({email:'admin@gmail.com',password:'adminadmin'})
    const [load,setLoad]=useState(false)

    const navigate=useNavigate()
    const PORT=process.env.REACT_APP_URL_PORT
    
    if(state){
        navigate('/')
    }
    function inputHandle(e){
        setData({...data,[e.target.name]:e.target.value})
    }
    function userLogin(){
        setLoad(true)
        if(data.email!=="" && data.password!==""){
            axios.post(`https://${PORT}/admin/user_search`,{id: data.email})
            .then(
                (res)=>{
                    if(res.data!==""){
                        if(res.data.password===data.password){
                            localStorage.setItem("sangeetUser",JSON.stringify(res.data))
                            dispatch({type:"USER",payload:true})
                            navigate('/')
                        }
                        else{
                            alert("Your email or password is incorrect, please try again.")
                            setLoad(false)
                        }
                    }
                    else{
                        alert("Your email or password is incorrect, please try again.")
                        setLoad(false)
                    }
                }
            )
        }
        else{
            alert("please fill all the input fields!")
            setLoad(false)
        }
    }
    return(
        <div className="row mt-5">
            <div className="col-md-4 mt-3"></div>
            <div className="col-md-4 lim">
                <center>
                    <h5 className="mt-5">Login</h5>
                    <input type="email" value={data.email} name={"email"} placeholder="E-mail" onChange={inputHandle}/>
                    <input type="password" value={data.password} name={"password"} placeholder="Password" onChange={inputHandle}/><br/>
                    <div>
                        <Link to="/forgot_password">Forgot Password?</Link>
                    </div>
                    <div>
                        <Link to="/signup">Don't have an account?</Link>
                    </div>
                    <button type="submit" className="btn btn-dark btn-sm" onClick={userLogin} disabled={load}>Login</button>
                </center>
            </div>
            <div className="col-md-4"></div>
        </div>
    )
}